import React from 'react'
import PageTitle from "./PageTitle";
import projectList from "../Lists/Projects";
import ProjectCard from "./ProjectCard";

const Projects = (props) => {

    return (
        <section>
            <div className="project-wrapper common-padding">
                <PageTitle title="Work" />
                <div className="mt-4 w-100 projectCard-wrapper">
                    {projectList.map((project, i) => (
                        <ProjectCard key={i} project={project} />
                    ))}
                </div>
            </div>
            <div className="navi-wrapper">
                <button className="navi-btn" onClick={() => props.setActive("skills")} >
                    <i className='fa fa-arrow-up'></i>
                </button>
                <button className="navi-btn" onClick={() => props.setActive("interests")} >
                    <i className='fa fa-arrow-down'></i>
                </button>
            </div>
        </section>
    )
}

export default Projects